import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sig-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
